var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-collapse"},[_vm._t("trigger",null,null,{ toggle: _vm.toggle, isCollapsed: _vm.isCollapsed }),_vm._v(" "),_vm._t("default",null,null,{ isCollapsed: _vm.isCollapsed })],2)}
var staticRenderFns = []

export { render, staticRenderFns }